import React from "react";
import { createRoot } from "react-dom/client";
import { OverlaysProvider, OverlayToaster, OverlayToasterProps, ToastProps } from "@blueprintjs/core";
import styles from "./App.module.scss";

export const ToasterOptions: OverlayToasterProps = {
  position: "top-right",
  className: styles.mainToaster,
};

/**
 * Тостер внутри дерева React (`<OverlayToaster>` в Notifications) рисуем без
 * портала — он и так стоит там, где нужно. Статической фабрике этот проп
 * передавать нельзя: она всегда создаёт свой элемент и ругается в консоль.
 */
export const InlineToasterOptions: OverlayToasterProps = {
  ...ToasterOptions,
  usePortal: false,
};

/**
 * Статический сервис уведомлений — для мест вне дерева React (загрузка файлов,
 * блокировка ухода со страницы).
 *
 * Тостер живёт в своём корне, а не в дереве приложения, поэтому провайдер
 * оверлеев из `App` до него не достаёт — приходится ставить свой: без него
 * Blueprint 5 работает через устаревший модульный стек и пишет об этом в консоль
 * на каждый рендер, а в шестой версии это перестанет работать.
 *
 * Отсюда и `createAsync` вместо `create`: только он даёт подставить свою функцию
 * рендера. Промис резолвится сразу после монтирования, а уведомления показывают
 * из обработчиков — то есть заведомо позже.
 *
 * Корень у тостера отдельный: Blueprint создаёт ему свой контейнер вне `#root`
 * и зовёт функцию рендера один раз, при создании.
 */
const toaster = OverlayToaster.createAsync(ToasterOptions, {
  domRenderer: (element, container) => {
    createRoot(container).render(<OverlaysProvider>{element}</OverlaysProvider>);
  },
});

export const Notificator = {
  show(props: ToastProps, key?: string) {
    void toaster.then((instance) => instance.show(props, key));
  },
};
